import PainelAPI from '../../api/painel';

const TOAST_AUTO_DISMISS_MS = 12000;
let toastIdCounter = 0;

const state = {
  requests: [],
  toasts: [],
  activeAttendance: null,
  uiFlags: { isFetching: false, isAttending: {} },
};

const getters = {
  getRequests: $state => $state.requests,
  getPendingRequests: $state =>
    $state.requests.filter(r => r.status === 'pending'),
  getAttendedRequests: $state =>
    $state.requests.filter(r => r.status === 'attended'),
  getPendingCount: $state =>
    $state.requests.filter(r => r.status === 'pending').length,
  getToasts: $state => $state.toasts,
  getActiveAttendance: $state => $state.activeAttendance,
  getUiFlags: $state => $state.uiFlags,
};

const mutations = {
  SET_REQUESTS($state, requests) {
    $state.requests = requests;
  },
  UPSERT_REQUEST($state, request) {
    const idx = $state.requests.findIndex(r => r.id === request.id);
    if (idx >= 0) $state.requests.splice(idx, 1, request);
    else $state.requests.unshift(request);
  },
  ADD_TOAST($state, toast) {
    $state.toasts.push(toast);
  },
  REMOVE_TOAST($state, toastId) {
    $state.toasts = $state.toasts.filter(t => t.toastId !== toastId);
  },
  SET_UI($state, { flag, value }) {
    $state.uiFlags[flag] = value;
  },
  SET_ATTENDING($state, { id, value }) {
    $state.uiFlags.isAttending = {
      ...$state.uiFlags.isAttending,
      [id]: value,
    };
  },
  SET_ACTIVE_ATTENDANCE($state, request) {
    $state.activeAttendance = request;
  },
};

const actions = {
  fetchRequests: async ({ commit }, params = {}) => {
    commit('SET_UI', { flag: 'isFetching', value: true });
    try {
      const { data } = await PainelAPI.fetchHumanAttentionRequests(params);
      commit('SET_REQUESTS', data.payload || []);
    } finally {
      commit('SET_UI', { flag: 'isFetching', value: false });
    }
  },

  attend: async ({ commit }, id) => {
    commit('SET_ATTENDING', { id, value: true });
    try {
      const { data } = await PainelAPI.attendHumanAttentionRequest(id);
      commit('UPSERT_REQUEST', data.payload);
      return data.payload;
    } finally {
      commit('SET_ATTENDING', { id, value: false });
    }
  },

  startAttendance: ({ commit }, request) => {
    commit('SET_ACTIVE_ATTENDANCE', request);
  },

  resolveAttendance: async ({ commit, state: _state }) => {
    const request = _state.activeAttendance;
    if (!request) return;
    commit('SET_ATTENDING', { id: request.id, value: true });
    try {
      const { data } = await PainelAPI.attendHumanAttentionRequest(request.id);
      commit('UPSERT_REQUEST', data.payload);
      commit('SET_ACTIVE_ATTENDANCE', null);
    } finally {
      commit('SET_ATTENDING', { id: request.id, value: false });
    }
  },

  receiveBroadcast: ({ commit }, payload) => {
    commit('UPSERT_REQUEST', payload);
    toastIdCounter += 1;
    const toastId = toastIdCounter;
    commit('ADD_TOAST', {
      toastId,
      request: payload,
      createdAt: Date.now(),
    });
    setTimeout(() => {
      commit('REMOVE_TOAST', toastId);
    }, TOAST_AUTO_DISMISS_MS);
  },

  receiveUpdate: ({ commit }, payload) => {
    commit('UPSERT_REQUEST', payload);
  },

  dismissToast: ({ commit }, toastId) => {
    commit('REMOVE_TOAST', toastId);
  },
};

export default { namespaced: true, state, getters, mutations, actions };
